module.exports = __webpack_public_path__ + "static/media/10.95e9987e.png";